import { useHasPermission } from 'helpers/global.helper/global.helper'
import React, { ReactElement, useState } from 'react'

import { useTranslation } from 'react-i18next'
import Button from 'ui/atoms/Button/Button'

import styles from './wrikeFormHandler.module.less'

type WrikeFormHandlerProps = {
  iFrameSource: string
  title: string
  hideTitle?: boolean
}

export default function WrikeFormHandler({
  iFrameSource,
  title,
  hideTitle = false,
}: WrikeFormHandlerProps): ReactElement {
  const { t } = useTranslation()

  const [wrikeFormIsOpen, setWrikeFormState] = useState(false)

  const hasHideContactUsPermission = useHasPermission('hide_contact_us')

  if (hasHideContactUsPermission) {
    return <></>
  }

  return (
    <>
      {wrikeFormIsOpen && (
        <div className={styles.WrikeFormHandler_Form}>
          <div className={styles.WrikeFormHandler_Button__close}>
            <Button link onClick={() => setWrikeFormState(!wrikeFormIsOpen)}>
              {t(`Close`)}
            </Button>
          </div>
          <iframe width="100%" height="100%" src={iFrameSource} frameBorder="1" title={title} />
        </div>
      )}
      <Button
        link
        style={{ color: 'white' }}
        marginRight
        icon={`fal fa-comments`}
        aria-label={hideTitle ? title : undefined}
        onClick={() => setWrikeFormState(!wrikeFormIsOpen)}
        tooltip={hideTitle ? title : undefined}
      >
        {hideTitle ? `` : title}
      </Button>
    </>
  )
}
